import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function Urgency() {
  const initialTime = 23 * 3600 + 43 * 60 + 36;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-8 md:py-12 bg-red-900/20 border-y border-red-900/50 relative overflow-hidden" data-id="element-404">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LCAwLCAwLCAwLjA1KSIvPjwvc3ZnPg==')] opacity-50" data-id="element-405" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-406">
        <div className="max-w-3xl mx-auto text-center" data-id="element-407">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-408">
            <div className="flex items-center gap-2 text-red-500 font-bold tracking-widest uppercase mb-2 text-xs md:text-base" data-id="element-409">
              <Clock size={16} data-id="element-410" />
              <span data-id="element-411">Oferta de Lanzamiento</span>
            </div>

            <h2 className="text-2xl md:text-4xl font-display text-white mb-3 md:mb-6" data-id="element-412">
              +$8.000 DESPUÉS
            </h2>

            <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-4" data-id="element-413">
              LANZAMIENTO TERMINA EN
            </p>

            <div className="flex gap-2 md:gap-4 justify-center mb-5 md:mb-8" data-id="element-414">
              <div className="flex flex-col items-center" data-id="element-415">
                <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-3xl md:text-5xl w-14 h-16 md:w-20 md:h-24 flex items-center justify-center rounded-lg shadow-lg" data-id="element-416">
                  {formatTime(hours)}
                </div>
                <span className="text-[10px] md:text-xs text-slate-400 mt-1.5 md:mt-2 uppercase" data-id="element-417">
                  Horas
                </span>
              </div>
              <div className="text-3xl md:text-5xl font-display text-red-500 mt-1.5 md:mt-2" data-id="element-418">
                :
              </div>
              <div className="flex flex-col items-center" data-id="element-419">
                <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-3xl md:text-5xl w-14 h-16 md:w-20 md:h-24 flex items-center justify-center rounded-lg shadow-lg" data-id="element-420">
                  {formatTime(minutes)}
                </div>
                <span className="text-[10px] md:text-xs text-slate-400 mt-1.5 md:mt-2 uppercase" data-id="element-421">
                  Minutos
                </span>
              </div>
              <div className="text-3xl md:text-5xl font-display text-red-500 mt-1.5 md:mt-2" data-id="element-422">
                :
              </div>
              <div className="flex flex-col items-center" data-id="element-423">
                <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-3xl md:text-5xl w-14 h-16 md:w-20 md:h-24 flex items-center justify-center rounded-lg shadow-lg" data-id="element-424">
                  {formatTime(seconds)}
                </div>
                <span className="text-[10px] md:text-xs text-slate-400 mt-1.5 md:mt-2 uppercase" data-id="element-425">
                  Segundos
                </span>
              </div>
            </div>

            <p className="text-xs md:text-base text-slate-300 mb-2" data-id="element-426">
              Y no vuelve a bajar
            </p>

            <div className="w-full max-w-md mx-auto mt-3 md:mt-4" data-id="element-427">
              <div className="flex justify-between text-xs md:text-sm font-bold mb-1" data-id="element-428">
                <span className="text-rugby-gold-400" data-id="element-429">68% TOMADOS</span>
                <span className="text-slate-400" data-id="element-430">Cupos restantes</span>
              </div>
              <div className="h-2.5 md:h-3 w-full bg-rugby-green-950 rounded-full overflow-hidden border border-rugby-green-800" data-id="element-431">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '68%'
              }} viewport={{
                once: true
              }} transition={{
                duration: 1,
                delay: 0.5
              }} className="h-full bg-gradient-to-r from-rugby-gold-600 to-rugby-gold-400" data-id="element-432" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}